import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import AdminLeads from "@/pages/AdminLeads";
import SmoothScroll from "@/components/SmoothScroll";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <SmoothScroll>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin/leads" element={<AdminLeads />} />
          </Routes>
        </BrowserRouter>
      </SmoothScroll>
      <div className="grain" aria-hidden="true" />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid #262626",
            color: "#f5f5f5",
            borderRadius: 2,
          },
        }}
      />
    </div>
  );
}

export default App;
